export const defaultSettings = {
  key: 'main',
  currency: '₽',
  role: 'courier',
  weekStartsOn: 1,
  payoutDay: 2,
  payoutDelayWeeks: 1,
  taxRounding: 'kopecks',
  weeklyTarget: 15000,
  backup: {
    lastExportAt: ''
  },
  interface: {
    compactTables: false,
    rememberShiftValues: false
  },
  quickShift: {
    enabled: false,
    startTime: '08:00',
    hours: 8,
    orders: 20
  }
}

export const defaultConditions = [
  { code: 'rain', title: 'Дождь', emoji: '🌧️' },
  { code: 'snow', title: 'Снег', emoji: '❄️' },
  { code: 'highDemand', title: 'Высокий спрос', emoji: '🔥' },
  { code: 'holiday', title: 'Праздник', emoji: '🎉' },
  { code: 'manual', title: 'Ручной бонус', emoji: '➕' }
]

export const sampleBonusRules = [
  {
    title: 'Дождь: +10 ₽ к заказу',
    type: 'per_order',
    amount: 10,
    conditionCode: 'rain',
    effectiveFrom: '',
    effectiveTo: '',
    active: true,
    description: 'Применяется к смене, если отмечено условие «Дождь».'
  },
  {
    title: 'После 23:00: +30 ₽ к часу',
    type: 'after_time',
    amount: 30,
    timeFrom: '23:00',
    timeTo: '00:00',
    conditionCode: '',
    effectiveFrom: '',
    effectiveTo: '',
    active: true,
    description: 'Считает часы после 23:00 по времени начала и окончания смены.'
  },
  {
    title: '23:00–00:00: +30 ₽ к заказу',
    type: 'time_order',
    amount: 30,
    timeFrom: '23:00',
    timeTo: '00:00',
    conditionCode: '',
    effectiveFrom: '',
    effectiveTo: '',
    active: true,
    description: 'Применяется к заказам в указанном интервале. Если заказы введены общим числом за смену, приложение распределяет их пропорционально времени.'
  }
]
